import "./InfoLine.css";

function InfoLine({ }) {
    const INFO = [
        {
            title: `Delivery`,
            text: `We&nbsp;offer 24-hour delivery across Dubai and worldwide shipping.`,
        },
        {
            title: `Payment`,
            text: `Pay in&nbsp;cash (USD, RUB, AED), bank&nbsp;card or&nbsp;crypto. All prices are in&nbsp;USD at&nbsp;a&nbsp;1:1 ratio with USDT`,
        },
        {
            title: `Authenticity Checks`,
            text: `We&nbsp;offer additional verification and certification upon request for extra timepiece of&nbsp;mind.`,
        },
    ]
    return (
        <div className={`info-line`}>
            {INFO.map((item) => {
                return (
                    <div className="info-line__item">
                        <p className="info-line__item__title">{item.title}</p>
                        <p className="info-line__item__text" dangerouslySetInnerHTML={{
                            __html: item.text
                        }}></p>
                    </div>
                )
            })}
        </div>
    );
}

export default InfoLine;